/** Astérisque rouge pour les champs obligatoires (affichage uniquement). */
export function RequiredMark() {
  return (
    <span className="ml-0.5 font-semibold text-red-600" title="Obligatoire" aria-hidden="true">
      *
    </span>
  );
}
